export default __webpack_public_path__ + "f01e3a554e2eaddeb7b459e3e5b45e94.png";